@for (session of sessions; track session.id) {
  <lv-attendance-timeline-session
    [session]="session"
    [sessionCount]="sessions.length"
    [attr.data-start]="session.startedAt | date: 'short'"
  >
    @for (anomaly of session.anomalies; track anomaly.id) {
      <lv-attendance-timeline-anomaly
        [anomaly]="anomaly"
        [sessionStart]="session.startedAt"
        [sessionEnd]="session.finishedAt"
        [attr.data-tip]="anomaly.createdAt | date: 'mediumTime'"
      ></lv-attendance-timeline-anomaly>
    }
    @for (event of session.events; track event.id) {
      <lv-attendance-timeline-event
        [event]="event"
        [sessionStart]="session.startedAt"
        [sessionEnd]="session.finishedAt"
        [attr.data-tip]="`${event.title} (${(event.createdAt | date: 'mediumTime')})`"
      ></lv-attendance-timeline-event>
    }
  </lv-attendance-timeline-session>
}
